import { type SearchCriteria } from '@/entities/searchCriteria';
import type { QueryObject } from '@/shared/lib/serializeQuery';

export const SEARCH_ID_QUERY_KEY = 'sid';

const SEARCH_ID_ALPHABET = '1234567890abcdefghijklmnopqrstuvwxyz';

const SEARCH_ID_LENGTH = 10;

export function generateSearchId(): string {
  return Array.from(
    { length: SEARCH_ID_LENGTH },
    () => SEARCH_ID_ALPHABET[Math.floor(Math.random() * SEARCH_ID_ALPHABET.length)],
  ).join('');
}

export function getSearchSessionKey(criteria: SearchCriteria): string {
  return JSON.stringify(criteria);
}

export function toSearchIdQuery(searchId: string): QueryObject {
  return searchId ? { [SEARCH_ID_QUERY_KEY]: searchId } : {};
}

export function fromSearchIdQuery(query: QueryObject): string {
  return typeof query[SEARCH_ID_QUERY_KEY] === 'string' ? (query[SEARCH_ID_QUERY_KEY] as string) : '';
}
